<template>
	<div class="offers">
		<h2 class="level-one-heading mb-5">Medlemserbjudanden</h2>
		<hr>
		<div class="mb-5">
			Här finner du aktuella medlemserbjudanden. I takt med att du stiger i medlemsnivå (Level) tillkommer fler produkter och bättre medlemspriser.
		</div>
		<toggle-button
			v-for="tab in tabs"
			v-model="selectedTab"
			:activeValue="tab"
			:text="tab.name"
			:key="tab.id"
			sticky
			@click="toggleHighlight"
		/>
		<product-browser
			v-if="resetData.length"
			ref="browser"
			:url="currentUrl"
			:resetData="resetData"
		/>
	</div>
</template>

<script>
export default {
	willSendScrollTriggerEvent: true,
	data () {
		return {
			tabs: {
				all:  {
					id: 'all',
					name: 'Alla erbjudanden',
				},
				highlights:  {
					id: 'highlights',
					name: 'Highlights',
				},
			},
			memberDeals: [{
				type: 'memberDeals',
				value: true,
			}],
			memberHighlights: [{
				type: 'memberDeals',
				value: true,
			}, {
				type: 'memberDealsHighlights',
				value: true,
			}],
			selectedTab: null,
			resetData: [],
		};
	},
	computed: {
		currentUrl () {
			const selectedTab = this.selectedTab === this.tabs.all ? 'memberDeals' : 'memberHighlights'
			return selectedTab + '/' + this.$attrs.user.rankLevel;
		},
	},
	methods: {
		toggleHighlight () {
			const lastFilter = this.filters;
			if (this.selectedTab === this.tabs.all) {
				this.filters = this.memberDeals;
			} else if (this.selectedTab === this.tabs.highlights) {
				this.filters = this.memberHighlights;
			}

			if (lastFilter != this.filters) {
				this.reset();
			}
		},
		reset () {
			this.resetData = [[{
				type: this.selectedTab === this.tabs.all ? 'memberDeals' : 'memberHighlights',
				value: this.$attrs.user.rankLevel,
			}], this.filters, true];
		},
	},
	mounted () {
		if (this.$route.query.showHighlights === true) {
			this.selectedTab = this.tabs.highlights;
			this.filters = this.memberHighlights;
		} else {
			this.selectedTab = this.tabs.all;
			this.filters = this.memberDeals;
		}
		this.reset();
	},
};
</script>
